import { ServerConfig } from "@/config/config";
import { RoadmapItem } from "@/models/roadmap-item";
import { App } from "@/utils/apps";
import { Axios } from "./auth-service";

export class RoadmapServiceClass {
	private readonly adminUrl:string = `${ServerConfig.host}/admin/roadmap`;

	public async getItem(id:number):Promise<RoadmapItem>{
		let result = await Axios.get(`${this.adminUrl}/${id}`);
		return new RoadmapItem(result.data);
	}

	public async getItemsByAppName(appName:App):Promise<RoadmapItem[]>{
		let result = await Axios.get(`${this.adminUrl}/by-app-name/${appName}`);
		return result.data.map((r:any)=>new RoadmapItem(r));
	}

	public async postItem(item:RoadmapItem):Promise<RoadmapItem>{
		let result = await Axios.post(`${this.adminUrl}`, item.getJSON());
		return new RoadmapItem(result.data);
	}

	public async putItem(item:RoadmapItem):Promise<RoadmapItem>{
		let result = await Axios.put(`${this.adminUrl}/${item.id}`, item.getJSON());
		return new RoadmapItem(result.data);
	}

	public async deleteItem(item:RoadmapItem):Promise<void>{
		await Axios.delete(`${this.adminUrl}/${item.id}`);
	}

	public async uploadImage(file:File):Promise<string>{
		let data = new FormData();
		data.append("file", file);
		let result = await Axios.post(`${this.adminUrl}/file`, data);
		return `${ServerConfig.host}/files/${result.data.token}`;
	}

	public async setPriorities(items:RoadmapItem[]):Promise<void>{
		await Axios.post(`${this.adminUrl}/set-priorities`, items.map(i=>{
			return {
				id: i.id,
				priority: i.priority
			};
		}));
	}
}

export const RoadmapService = new RoadmapServiceClass();